const ALREADY_PLURAL = new Set(['Kicks']);

const pluralizeCarModel = (model?: string): string => {
  if (!model) {
    return '';
  }

  // Guard against re-suffixing a value that arrives already possessive (e.g. a legacy
  // backend payload during a staggered deploy, or a rollback) — "Accord's" -> "Accord".
  const name = model.replace(/['’]s$/i, '');

  if (ALREADY_PLURAL.has(name)) {
    return name;
  }

  if (/s$/i.test(name)) {
    return `${name}'s`;
  }

  // Acronym-style trims (RX, MDX, TLX) read naturally with a plain "s" ("RXs"); only
  // word-like x/z/ch/sh endings (Equinox) need "-es" to avoid "RXes"/"MDXes".
  const isAcronym = name === name.toUpperCase();
  if (!isAcronym && (/[xz]$/i.test(name) || /ch$/i.test(name) || /sh$/i.test(name))) {
    return `${name}es`;
  }

  return `${name}s`;
};

export default pluralizeCarModel;
